import { safeFilenameSegment } from "../values/filename";

export const TENANT_OBJECT_ROOT = "tenants";

export const MAX_STORED_FILE_BYTES = 20 * 1024 * 1024;

export function buildTenantObjectPath(tenantId: number, segments: readonly (string | number)[]): string {
  return [TENANT_OBJECT_ROOT, tenantId, ...segments].join("/");
}

export function buildDocumentSlotPath(params: {
  tenantId: number;
  entitySegment: string;
  entityId: number;
  filename: string;
}): string {
  const { tenantId, entitySegment, entityId, filename } = params;
  return buildTenantObjectPath(tenantId, [entitySegment, entityId, filename]);
}

export function buildDocumentSlotVersionPath(params: {
  tenantId: number;
  entitySegment: string;
  entityId: number;
  documentType: string;
  versionId: string;
  extension: string;
}): string {
  const { tenantId, entitySegment, entityId, documentType, versionId, extension } = params;
  return buildTenantObjectPath(tenantId, [entitySegment, entityId, "versions", documentType, `${versionId}.${extension}`]);
}

export function buildDocumentSlotDownloadName(params: {
  identifier: string | null | undefined;
  suffix: string;
  extension: string;
}): string {
  const { identifier, suffix, extension } = params;
  const safeIdentifier = safeFilenameSegment(identifier ?? "");
  return safeIdentifier ? `${safeIdentifier}_${suffix}.${extension}` : `${suffix}.${extension}`;
}

export type DocumentSlotFileInput = {
  filename: string;
  mimeType: string;
  size: number;
};

export type DocumentSlotFileValidation =
  | { ok: true }
  | { ok: false; reason: "invalid_extension" | "invalid_mime_type" | "file_too_large" };

export function validateDocumentSlotFile(
  file: DocumentSlotFileInput,
  rules: { extension: string; mimeType: string; maxBytes: number },
): DocumentSlotFileValidation {
  if (!file.filename.toLowerCase().endsWith(`.${rules.extension}`)) {
    return { ok: false, reason: "invalid_extension" };
  }
  if (file.mimeType !== rules.mimeType) {
    return { ok: false, reason: "invalid_mime_type" };
  }
  if (file.size > rules.maxBytes) {
    return { ok: false, reason: "file_too_large" };
  }
  return { ok: true };
}
